import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxCurrencyDirective } from 'ngx-currency';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { InterceptorService } from './services/interceptor.service';
import { LoginModule } from './modules/login/login.module';
import { EncarregadoModule } from './modules/encarregado/encarregado.module';
import { NotFoundModule } from './modules/not-found/not-found.module';
import { EngenhariaModule } from './modules/engenharia/engenharia.module';
import { HomeModule } from './modules/home/home.module';
import { LogsModule } from './modules/logs/logs.module';
import { RecursosHumanosModule } from './modules/recursos-humanos/recursos-humanos.module';
import { SuprimentosModule } from './modules/suprimentos/suprimentos.module';
import { PlanejamentoModule } from './modules/planejamento/planejamento.module';
import { createBuiltUpSentryErrorHandler } from './core/sentry/sentry.config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgxCurrencyDirective,
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    LoginModule,
    RecursosHumanosModule,
    EncarregadoModule,
    EngenhariaModule,
    SuprimentosModule,
    PlanejamentoModule,
    LogsModule,
    HomeModule,
    NotFoundModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useFactory: createBuiltUpSentryErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    provideEnvironmentNgxMask({ validation: false }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
